var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"aria-hidden":"true","role":"img","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19 13H5v-2h14v2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }